import { Modal, notification } from "antd";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from 'yup';
import axiosInstance from "../../../../../../Services/axiosCommon";

import { CancelButton, SubmitButton } from "../../../../../../Components/Utils/Buttons";
import { NuInput, NuTextArea } from "../../../../../../Components/Utils/Input";
import FormikSelectTwo from "../../../../../../Components/Utils/Select";
import DropDownAddMetaData from "../../../../../../Components/Utils/selectAddMetaData copy";

function CreateSubManpowerbug({
  open,
  onCancel,
  getData,
  itemsCategory,
  projectId,
  itId,
  Type,
  refManPowerType = () => {},
  Category,
  refManPowerCategory = () => {},
}) {
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const initialValues = {
    projectId: "",
    title_id: "",
    designation: "",
    category: "",
    type: "",
    quantity: "",
    noOfDays: "",
    hours: "",
    comments: ""
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      designation: yup.string().required("Designation Name is required"),
    }),
    onSubmit: (value, { resetForm }) => {
      setIsLoading(true);
      const payload = {
        ...value,
        projectId: Number(projectId),
        title_id: itId,
      };

      axiosInstance
        .post(`/man_power_cost/single-mp`, payload)
        .then((res) => {
          if (res.status === 201 || res.data.status === true) {
            setIsLoading(false);
            getData();
            resetForm();
            api.success({
              message: `Material Item created successfully`,
              description: res?.data?.msg || "Added to Title",
              placement: "bottomRight",
            });
            onCancel();
          } else {
            api.error({
              message: `Material Item creation failed`,
              description: res?.data?.msg || "Network error",
              placement: "bottomRight",
            });
            setIsLoading(false);
          }
        })
        .catch((err) => {
          api.error({
            message: `Material Item creation failed`,
            description: err?.data?.msg || "Server or network error",
            placement: "bottomRight",
          });
          setIsLoading(false);
        });
    },
  });
  

  return (
    <>
      {contextHolder}
      <Modal
        open={open}
        title={"Create Manpower"}
        width={"50%"}
        className="my-modal"
        centered
        footer={[]}
        onCancel={onCancel}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="w-full flex flex-wrap">
            <NuInput
              type="text"
              label="Designation"
              placeholder="Designation"
              formik={formik}
              name="designation"
              width="w-full"
              isRequired={true}
            />

            <FormikSelectTwo
              type="text"
              label="Category"
              placeholder="Category"
              Options={itemsCategory}
              formik={formik}
              name="category"
              width="w-full md:w-1/2"
              getFunc={refManPowerCategory}
            />

            <DropDownAddMetaData
              label="Type"
              Options={Type}
              formik={formik}
              placeholder="Choose"
              name="type"
              width="w-full md:w-1/2"
              getFunc={refManPowerType} 
              displayProperty="Type"
              propertyName="ManPowerType"
            />

            <NuInput
              type="number"
              label="Quantity"
              placeholder="Quantity"
              formik={formik}
              name="quantity"
              width="w-full md:w-1/2"
            />

            <NuInput
              type="number"
              label="No of Days"
              placeholder="No of Days"
              formik={formik}
              name="noOfDays"
              width="w-full md:w-1/2"
            />

            <NuInput
              type="number"
              label="Hours"
              placeholder="Hours"
              formik={formik}
              name="hours"
              width="w-full md:w-1/2"
            />

            <NuTextArea
              label="Comments"
              placeholder="Comments"
              formik={formik}
              name="comments"
              width="w-full md:w-1/2"
            />

            <div className="w-full flex justify-end gap-2 mt-2 md:mr-4">
              <CancelButton handleClick={onCancel} />
              <SubmitButton isLoading={isLoading} />
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
}

export default CreateSubManpowerbug;
